import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { adjustBalanceColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getAdjustBalance } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "msisdn",
  "balance_type",
  "amount",
  "subscription_id",
  "status",
  "last_updated",
];

const AdjustBalanceBatch = () => (
  <BatchDetail
    title="Adjust Balance"
    apiGet={__getAdjustBalance}
    client={CLIENTS.pwg}
    columnsFactory={(ctx) => adjustBalanceColumns({ ...ctx, iccidHeaderName: "ESN" })}
    copyKeys={COPY_KEYS}
    exportAction="adjust_balance"
    retryOperation="adjust_balance"
    showTerminate
    terminateOperation="adjust_balance"
    getRowPath={(row) => `/pwg/adjust_balance/${row.id}`}
  />
);

export default AdjustBalanceBatch;
